const STORAGE_PREFIX = "enrein:projectDisplayName:";

export function saveProjectDisplayName(projectId: string, businessName: string): void {
  if (typeof sessionStorage === "undefined") return;
  const trimmed = businessName.trim();
  if (!trimmed) return;
  sessionStorage.setItem(`${STORAGE_PREFIX}${projectId}`, trimmed);
}

export function readProjectDisplayName(projectId: string): string | null {
  if (typeof sessionStorage === "undefined") return null;
  const value = sessionStorage.getItem(`${STORAGE_PREFIX}${projectId}`);
  return value && value.length > 0 ? value : null;
}

export function readProjectDisplayNameMap(): Record<string, string> {
  if (typeof sessionStorage === "undefined") return {};
  const map: Record<string, string> = {};
  for (let index = 0; index < sessionStorage.length; index += 1) {
    const key = sessionStorage.key(index);
    if (!key?.startsWith(STORAGE_PREFIX)) continue;
    const projectId = key.slice(STORAGE_PREFIX.length);
    const name = sessionStorage.getItem(key);
    if (projectId.length > 0 && name && name.length > 0) {
      map[projectId] = name;
    }
  }
  return map;
}
